import React from "react";
import MaterialTable, { MTableToolbar } from "material-table";

import "react-toastify/dist/ReactToastify.css";

import { MDBIcon } from "mdbreact";

import PackagesCheckerInclusion from "./PackagesCheckerInclusion";

const PackagesCheckerTable = (props) => {
  const TitleBar = () => {
    return (
      <React.Fragment>
        <h5
          style={{
            fontFamily: "Roboto",
            fontWeight: "600",
            fontSize: "1em",
            padding: "0",
          }}
          className="brown-text h5-responsive pt-4"
        >
          {props.title}
        </h5>

        <p className="small">{props.description}</p>
      </React.Fragment>
    );
  };

  return (
    <React.Fragment>
      <MaterialTable
        title={<TitleBar></TitleBar>}
        components={{
          Toolbar: (props) => (
            <div>
              <MTableToolbar {...props} />
            </div>
          ),
        }}
        columns={[
          { title: "", field: "code", hidden: true },

          { title: "Package", field: "description" },

          { title: "Package Cost", field: "sellingprice" },
        ]}
        data={props.rows}
        //   options={{
        //     search: true,
        //     actionsColumnIndex: -1
        //     ,filtering:true
        //   }}

        options={{
          search: true,
          actionsColumnIndex: -1,
          filtering: true,
          detailPanelType: "single",

          cellStyle: {
            width: "100%",
            // paddingLeft: "0px",
          },
        }}
        detailPanel={[
          {
            icon: () => <MDBIcon icon="list" className="purple-text" />,
            openIcon: () => (
              <MDBIcon icon="chevron-down" className="red-text" />
            ),
            tooltip: "Package Inclusion",
            render: (rowData) => {
              return (
                <React.Fragment>
                  <PackagesCheckerInclusion
                    deployURL={props.deployURL}
                    apiServer={props.apiServer}
                    itemcode={rowData.code}
                    apiServerHybrid={props.apiServerHybrid}
                    toggleModal={props.toggleAddEdit}
                    refreshGrid={props.refreshGrid}
                    parentcode={rowData.code}
                  />
                </React.Fragment>
              );
            },
          },
        ]}
      />
    </React.Fragment>
  );
};

//
export default PackagesCheckerTable;
